import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//Angular Modules
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Material components Modules
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule} from '@angular/material/select';
import { MatListModule} from '@angular/material/list';
import { MatRadioModule} from '@angular/material/radio';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {MatExpansionModule} from '@angular/material/expansion';
import { PrioridadPipe } from './pipes/prioridad.pipe';
import { RecaptchaModule } from 'ng-recaptcha';

@NgModule({
  declarations: [
    PrioridadPipe
  ],
  imports: [
    CommonModule,
    MatToolbarModule
  ],
  exports: [
    FormsModule,
    RecaptchaModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatIconModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatCardModule,
    MatGridListModule,
    MatButtonModule,
    MatSelectModule,
    MatListModule,
    MatRadioModule,
    MatStepperModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatTooltipModule,
    MatExpansionModule,
    PrioridadPipe
  ]
})
export class SharedModule { }
